import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IDishAssignmentContext,
	DishAssignmentContext,
} from '../../../../../dishAssignmentState/dishAssignmentContext';
import SelectedItemForBreadcrumbs from 'components/SelectedItem/SelectedItemForBreadcrumbs';
import style from './DishCrumb.module.scss';

const DishCrumb: React.FC = () => {
	const { deleteDishFromSubcategory, dishes } = useContext<IDishAssignmentContext>(DishAssignmentContext);

	return (
		<div className={style.container} data-test="DishCrumb">
			<div className={style.scrollWrapper}>
				<Text
					className={style.crumbName}
					translationNameSpace="listing"
					translationKey="dishesLabel"
					size="s"
					weight="bold"
				/>
				{dishes.map((subcategory, i) => {
					const isAnyDishSelected = !!subcategory.dishes.length;

					return (
						<div key={subcategory.id} data-test={`item-${i}`}>
							{isAnyDishSelected && (
								<Text
									className={style.sectionName}
									translationKey={subcategory.name}
									size="xs"
									withTooltip={true}
								/>
							)}
							<div className={style.selectedItemWrapper}>
								{subcategory.dishes.map((dish) => {
									return (
										<SelectedItemForBreadcrumbs
											key={dish.id}
											label={dish.name || ''}
											onDelete={() => deleteDishFromSubcategory(subcategory.id, dish.id)}
										/>
									);
								})}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default DishCrumb;
